import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import SimilarityHeader from "./SimilarityHeader";
import ProductGroupCard from "./ProductGroupCard";
import useMergeProductGroups from "./useMergeProductGroups";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    maxWidth: "1400px",
    margin: "0 auto",
  },
  title: {
    marginBottom: theme.spacing(3),
    fontWeight: "bold",
    fontSize: "1.5rem",
  },
  productGroupContainer: {
    display: "flex",
    gap: theme.spacing(3),
    alignItems: "flex-start",
  },
  arrowIcon: {
    fontSize: "2rem",
    color: "#000",
    margin: `0 ${theme.spacing(2)}`,
    alignSelf: "center",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "400px",
  },
  emptyState: {
    textAlign: "center",
    padding: theme.spacing(4),
    color: "#666",
  },
}));

export default function MergeProductGroups(props) {
  const classes = useStyles();
  const {
    isLoading,
    isActionLoading,
    mergeSuggestions,
    groupADetails,
    groupBDetails,
    loadingGroups,
    handleMerge,
    handleReject,
  } = useMergeProductGroups();

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <CircularProgress />
      </div>
    );
  }

  if (mergeSuggestions.product_id===0) {
    return (
      <div className={classes.root}>
        <Typography className={classes.title}>Merge Product Groups</Typography>
        <div className={classes.emptyState}>
          <Typography>No merge suggestions available</Typography>
        </div>
      </div>
    );
  }

  const currentSuggestion = mergeSuggestions;

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>Merge Product Groups</Typography>

      {loadingGroups ? (
        <div className={classes.loadingContainer}>
          <CircularProgress />
        </div>
      ) : (
        <>
          <SimilarityHeader
            similarityScore={currentSuggestion.cosine_similarity}
            onReject={handleReject}
            onMerge={handleMerge}
            isActionLoading={isActionLoading}
          />

          <div className={classes.productGroupContainer}>
            <ProductGroupCard
              groupId={currentSuggestion.product_matching_group_id}
              groupTitle={groupADetails?.original?.fullname || `Group #${currentSuggestion.product_matching_group_id}`}
              groupData={groupADetails}
              isLoading={loadingGroups}
            />

            {currentSuggestion.product_matching_group_id < currentSuggestion.suggested_group_id? <ArrowBackIcon className={classes.arrowIcon} />:<ArrowForwardIcon className={classes.arrowIcon} />}

            <ProductGroupCard
              groupId={currentSuggestion.suggested_group_id}
              groupTitle={groupBDetails?.original?.fullname || `Group #${currentSuggestion.suggested_group_id}`}
              groupData={groupBDetails}
              isLoading={loadingGroups}
            />
          </div>
        </>
      )}
    </div>
  );
}
